//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { PATH_DASHBOARD } from '../../system/constants';
import { BASE_URL, DASHBOARD_ID_MY_SETTINGS, GO_TO_MY_DASHBOARD, GO_TO_MY_SETTINGS, HERE, USER_TYPE_JS, SEND_EMAIL_AGAIN } from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdTypography from '../../common/elemental/AfitdTypography';
// import AfitdButton from '../../common/elemental/AfitdButton';
import AfitdLink from '../../common/elemental/AfitdLink';
import CheckIcon from '@material-ui/icons/Check';
import LockIcon from '@material-ui/icons/Lock';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: { marginTop: 50 },
    goToMySettingsButton: { margin: 20 },
    title: { fontWeight: 'bold', fontSize: 26, marginTop: 40, marginBottom: 16, [theme.breakpoints.down('sm')]: { marginTop: 30 } },
    message: { textAlign: 'center', marginBottom: 40, [theme.breakpoints.down('sm')]: { marginBottom: 24 } },
    content: { textAlign: 'center' },
    sendEmailAgainLinkText: { marginTop: 24, fontWeight: 'bold' },
    sendEmailAgainLink: { fontWeight: 'bold' },
    mainIcon: { fontSize: 93, color: 'rgba(216, 216, 216, 1)' },
    iconContainer: { display: 'flex', justifyContent: 'center' },
    secondIcon: { background: 'rgba(29, 138, 139, 1)', color: '#fff', borderRadius: '50%', fontSize: 28, padding: 2, marginLeft: ' -31px', marginTop: '64px' },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // props,
        isJs,
        handleClickGoToMySettingsButton,
        handleClickLoginLink,
        handleClickResendButton,
    } = params;

    const defns = {
        root: { container: true, justify: 'center' },
        content: { item: true, xl: 10, lg: 10, md: 10, sm: 10, xs: 10 },
        title: { variant: 'h5', clsSkinnyBold: true /* clsLightBold: true */ },
        message: { variant: 'body1' },
        goToMySettingsButton: {
            variant: 'contained',
            color: 'secondary',
            label: isJs ? GO_TO_MY_DASHBOARD : GO_TO_MY_SETTINGS,
            onClick: handleClickGoToMySettingsButton,
        },
        continueToLogInText: { variant: 'body1', component: 'span' },
        sendEmailAgainLinkText: { variant: 'body1', component: 'p' },
        loginLink: {
            color: 'secondary',
            onClick: handleClickLoginLink,
            label: HERE,
        },
        sendEmailAgainLink: {
            color: 'secondary',
            onClick: handleClickResendButton,
            label: SEND_EMAIL_AGAIN,
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const PasswordResetSuccessful = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const appContext = useContext(AppContext);
    // const context = useContext(LayoutContext);

    const { currentUser } = appContext;
    const isJs = _get(currentUser, 'type') === USER_TYPE_JS;

    const history = useHistory();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleClickGoToMySettingsButton = async () => {
        history.push(`${BASE_URL}${PATH_DASHBOARD}/${DASHBOARD_ID_MY_SETTINGS}`);
    };

    const handleClickLoginLink = async () => {
        history.push(`${BASE_URL}${PATH_DASHBOARD}`);
    };
    const handleClickResendButton = async () => {
        alert('(Fake) Email sent! It might take up to 10 minutes for it to arrive your inbox.');
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, isJs, handleClickGoToMySettingsButton, handleClickLoginLink, handleClickResendButton });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.root}>
            <Grid {...defns.content}>
                <div {...defns.iconContainer}>
                    <LockIcon {...defns.mainIcon} />
                    <CheckIcon {...defns.secondIcon} />
                </div>
                <AfitdTypography {...defns.title}>Password Reset Successfully</AfitdTypography>
                <AfitdTypography {...defns.message}>Your password has been reset.</AfitdTypography>
                <AfitdTypography {...defns.needAnotherLinkText}>Need Another Password Reset Link?</AfitdTypography>
                <AfitdTypography {...defns.sendEmailAgainLinkText}>
                    <AfitdLink {...defns.sendEmailAgainLink} />
                </AfitdTypography>
            </Grid>
        </Grid>
    );
};

export default PasswordResetSuccessful;
